import { createAPI } from '@common'
export default {
  // 新建水印
  postMamWatermark: (config) => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0xbufsnbsl', 'POST', config),
  // 修改水印
  putMamWatermark: (config) => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0xbufsnbsl', 'PUT', config),
  // 获取水印详情
  getMamWatermark: (config) => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hfuXbufsnbsl', 'POST', config),
  // 获取视频上传必要的token，和地址
  getMamUploadNoTransAccesstoken: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0vqmpbe0opUsbot0bddfttuplfo', 'GET', config),
  // 通过视频url获取当前视频的信息
  getMamMediaInfo: (config) => createAPI('customEncryptApiName-1/0w20nbn0nfejb0jogp', 'GET', config),
  // 获取图片上传必要的token和地址
  getMamUploadPhotoAccesstoken: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0vqmpbe0qipup0bddfttuplfo', 'GET', config),
  // 通过云视id获取视频的详细信息
  getMamMediaInfoVcId: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0nfejb0jogp0wdJe', 'GET', config)
}
